enum AdsEventType {
  MODAL_SHOWED = 'ModalShowed',
  GIFT_CLICK = 'GiftClick',
  DENIED_CLICK = 'DeniedClick',
  AGREEMENT_CLICK = 'AgreementClick',
  CLOSE_CLICK = 'CloseClick'
}

export default AdsEventType
